const app = {
    //BASE_URL: 'http://192.168.0.100:8003',
    //BASE_URL: 'http://192.168.20.31:9097',
    BASE_URL: 'https://sistemas.mindef.gob.bo/reafucb',
    PREFIX_URL:'/api'
}

export default app;